import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./lib/auth";
import { SettingsProvider } from "./lib/settings";
import { ThemeProvider } from "./lib/theme";
import ProtectedRoute from "./components/ProtectedRoute";
import AdminLayout from "./components/AdminLayout";
import ClientLayout from "./components/ClientLayout";
import Login from "./pages/Login";
import Activate from "./pages/Activate";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import AdminDashboard from "./pages/AdminDashboard";
import AdminProjectDetail from "./pages/AdminProjectDetail";
import AdminClients from "./pages/AdminClients";
import AdminClientDetail from "./pages/AdminClientDetail";
import AdminSettings from "./pages/AdminSettings";
import ClientSelector from "./pages/ClientSelector";
import ClientProject from "./pages/ClientProject";
import ClientOverview from "./pages/ClientOverview";
import ClientDocuments from "./pages/ClientDocuments";
import ClientUploads from "./pages/ClientUploads";
import ClientProfile from "./pages/ClientProfile";
import ClientProjectTeam from "./pages/ClientProjectTeam";
import ClientTeam from "./pages/ClientTeam";
import ClientNotifications from "./pages/ClientNotifications";
import ClientAccount from "./pages/ClientAccount";
import PoweredByBadge from "./components/PoweredByBadge";
import { Toaster } from "sonner";

function App() {
  return (
    <SettingsProvider>
      <ThemeProvider>
        <AuthProvider>
          <BrowserRouter>
            <Toaster theme="dark" position="top-right" />
            <PoweredByBadge />
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/activate" element={<Activate />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />

              {/* Admin area */}
              <Route
                path="/admin"
                element={
                  <ProtectedRoute role="admin">
                    <AdminLayout />
                  </ProtectedRoute>
                }
              >
                <Route index element={<AdminDashboard />} />
                <Route path="projects/:id" element={<AdminProjectDetail />} />
                <Route path="clients" element={<AdminClients />} />
                <Route path="clients/:id" element={<AdminClientDetail />} />
                <Route path="settings" element={<AdminSettings />} />
              </Route>

              {/* Client area */}
              <Route
                path="/portal"
                element={
                  <ProtectedRoute role="client">
                    <ClientLayout />
                  </ProtectedRoute>
                }
              >
                <Route index element={<ClientSelector />} />
                <Route path="team" element={<ClientTeam />} />
                <Route path="notifications" element={<ClientNotifications />} />
                <Route path="account" element={<ClientAccount />} />
                <Route path="projects/:id" element={<ClientProject />}>
                  <Route index element={<ClientOverview />} />
                  <Route path="documents" element={<ClientDocuments />} />
                  <Route path="uploads" element={<ClientUploads />} />
                  <Route path="team" element={<ClientProjectTeam />} />
                  {/* Legacy /profile route — kept so old links don't 404 */}
                  <Route path="profile" element={<ClientProfile />} />
                </Route>
              </Route>

              <Route path="/" element={<Navigate to="/login" replace />} />
              <Route path="*" element={<Navigate to="/login" replace />} />
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </ThemeProvider>
    </SettingsProvider>
  );
}

export default App;
